import { rootActions } from "../reducers/root.slice";
import { TRootState } from "../store/create-store";
import { put, select } from "typed-redux-saga";
import { setStatus } from "../dom-utils";
import RowUtils from "../utils/RowUtils";
import { selectRootState } from "../selectors";

function* applyReorder(action: ReturnType<typeof rootActions.applyReorder>) {
  const { rows, leftPanel, rightPanel } = yield* select(selectRootState);

  const categories = action.payload;
  const { selectedColumn } = leftPanel;
  const { categoricalColumnsAsContinuous } = rightPanel;

  if (!selectedColumn) {
    throw new Error("No column selected");
  }

  setStatus("Applying reorder...");

  const newRows = rows.map((row) => {
    const newValue = RowUtils.getValue(row, selectedColumn);

    if (!newValue) {
      return row;
    }

    const mappedValue =
      categoricalColumnsAsContinuous[selectedColumn][Number(newValue)];

    return {
      ...row,
      [selectedColumn]: String(categories.indexOf(mappedValue)),
    };
  });

  yield* put(
    rootActions.applyReorderDone({
      rows: newRows,
      categoricalColumnsAsContinuous: {
        ...categoricalColumnsAsContinuous,
        [selectedColumn]: categories,
      },
    })
  );

  yield* put(rootActions.generateGraph());
}

export default applyReorder;
